import { Injectable } from '@angular/core';
import { DawaAddress } from '../model/interfaces/dawa-address';
import { Address } from '../model/interfaces/address';

@Injectable()
export class DawaAddressService
{
    public streetAddress: string;
    public nameFormatted: string;

    public constructor()
    {
    }

    public getAddressByDawaAddress(dawaAddress: DawaAddress): Address
    {
        if (dawaAddress == null)
        {
            return null;
        }

        const data = dawaAddress.data;

        const houseNumberParts: string[] = [];
        this.addAddressPropertyGroupToCollection(houseNumberParts, null, { value: data.husnr })
            .addAddressPropertyGroupToCollection(houseNumberParts, (group) => { return `${group}`; }, { value: data.etage, format: (floor) => `${floor}.` }, { value: data.dør });
        const houseNumber = houseNumberParts.join(' ');

        return {
            ZipCode: data.postnr,
            CityName: data.postnrnavn,
            CountryName: 'Danmark',
            StreetName: data.vejnavn,
            StreetNo: houseNumber,
            AreaName: data.supplerendebynavn,
            DawaId: data.id
        };
    }

    public formatAddress(address: Address): string
    {
        const streetNumber = address.StreetNo.replace(' ', ', ');

        return `${address.StreetName || ''} ${streetNumber || ''}, ${
          address.AreaName ? address.AreaName + ', ' : ''
        }${address.ZipCode || ''} ${address.CityName || ''}`;
    }

    private addAddressPropertyGroupToCollection(accumulator: string[], format: (propertyGroup: string) => string, ...properties: AddressProperty[]): DawaAddressService
    {
        const propertyItems = properties.reduce<string[]>((accumulator: string[], currentValue: AddressProperty) =>
        {
            const value = currentValue.value;
            if (currentValue.value != null)
            {
                accumulator.push(currentValue.format != null ? currentValue.format(value) : value);
            }

            return accumulator;
        }, []);

        if (propertyItems.length > 0)
        {
            const groupValue = propertyItems.join(' ');
            accumulator.push(format != null ? format(groupValue) : groupValue);
        }

        return this;
    }
}

interface AddressProperty
{
    value: string;
    format?: (value) => string;
}

